export default function Footer() {
  return (
    <footer className="relative w-full bg-night-blue">
      <div className="w-full px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 flex flex-col gap-6">
            <a href="#hero" className="flex items-center gap-3 group">
              <img
                src="https://storage.readdy-site.link/project_files/10dd6ff9-efe2-4505-9f10-13a932b2db17/bbccb5ae-0ca2-471a-a66e-ca9ecbb67a44_compressed_TL.webp"
                alt="TL Artes & Música"
                className="h-9 w-auto object-contain"
              />
              <span className="font-sans font-semibold text-sm tracking-wide text-white whitespace-nowrap">
                TL Artes &amp; Música
              </span>
            </a>
            <p className="font-sans text-[14px] text-white/50 leading-relaxed max-w-[320px]">
              A escola de música onde a excelência técnica encontra o propósito espiritual. Do zero ao avançado, no coração do Jardim Paulista.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com/tlartesemusica"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/40 text-white/60 hover:text-white transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="https://wa.me/5516992188698?text=Ol%C3%A1%21+Vim+pelo+site+da+TL+Artes+%26+M%C3%BAsica+e+gostaria+de+saber+mais+informa%C3%A7%C3%B5es+sobre+as+aulas."
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/40 text-white/60 hover:text-white transition-all duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-base"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <span className="font-sans text-[12px] font-semibold tracking-[0.15em] uppercase text-white/40">
              Contato
            </span>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-base text-white/40 mt-0.5"></i>
                <span className="font-sans text-[14px] text-white/70 leading-relaxed font-light">
                  R. Capivari, 34 &mdash; Jardim Paulista<br />Ribeirão Preto &mdash; SP
                </span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-whatsapp-line text-base text-white/40 mt-0.5"></i>
                <span className="font-sans text-[14px] text-white/70 font-light">(16) 99218-8698</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-instagram-line text-base text-white/40 mt-0.5"></i>
                <span className="font-sans text-[14px] text-white/70 font-light">@tlartesemusica</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 flex flex-col gap-6">
            <span className="font-sans text-[12px] font-semibold tracking-[0.15em] uppercase text-white/40">
              Navegação
            </span>
            <div className="flex flex-col gap-3">
              <a href="#hero" className="font-sans text-[14px] text-white/70 hover:text-white transition-colors font-light cursor-pointer">Início</a>
              <a href="#filosofia" className="font-sans text-[14px] text-white/70 hover:text-white transition-colors font-light cursor-pointer">Sobre Nós</a>
              <a href="#cursos" className="font-sans text-[14px] text-white/70 hover:text-white transition-colors font-light cursor-pointer">Cursos</a>
              <a href="#depoimentos" className="font-sans text-[14px] text-white/70 hover:text-white transition-colors font-light cursor-pointer">Depoimentos</a>
              <a href="#contato" className="font-sans text-[14px] text-white/70 hover:text-white transition-colors font-light cursor-pointer">Contato</a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="w-full px-6 md:px-12 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-sans text-[12px] text-white/35 font-light">
            &copy; {new Date().getFullYear()} TL Artes &amp; Música. Todos os direitos reservados.
          </span>
          <div className="flex items-center gap-6">
            <a href="#" className="font-sans text-[12px] text-white/35 hover:text-white/60 transition-colors font-light cursor-pointer">Política de Privacidade</a>
            <a href="#" className="font-sans text-[12px] text-white/35 hover:text-white/60 transition-colors font-light cursor-pointer">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
}